import { render, staticRenderFns } from "./FormElement.vue?vue&type=template&id=88f94126"
import script from "./FormElement.vue?vue&type=script&lang=js"
export * from "./FormElement.vue?vue&type=script&lang=js"
import style0 from "./FormElement.vue?vue&type=style&index=0&id=88f94126&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports